.wrapper {
    max-width: 42rem;
  }
  
  .container {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .datePickerContainer {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .comparisonText {
    color: var(--static-text-strong);
    font-size: var(--fs-small);
    font-weight: 600;
    line-height: normal;
    white-space: nowrap;
  }

  .compareToText {
    color: var(--static-text-strong);
    font-size: var(--fs-small);
    font-weight: 400;
    line-height: normal
  }